import { ComponentProps, ReactNode } from "react";
import { useTranslation } from "@localization/useTranslation";
import PlanDialogWrapper from "../planDialogWrapper/planDialogWrapper";
import { useAiFeatureAccess } from "./useAiFeatureAccess";

type TooltipPosition = ComponentProps<typeof PlanDialogWrapper>["position"];

interface IAiFeatureGateProps {
    // When locked (add-on not activated) the children should render a disabled look; clicking opens the upgrade dialog.
    children: ReactNode | ((state: { locked: boolean }) => ReactNode);
    position?: TooltipPosition;
}

function AiFeatureGate({ children, position }: IAiFeatureGateProps) {
    const { translateString } = useTranslation();
    const { planActivated, showAffordance } = useAiFeatureAccess();

    if (!showAffordance) return null;

    const locked = !planActivated;
    const content = typeof children === "function" ? children({ locked }) : children;

    return (
        <PlanDialogWrapper
            enabled={locked}
            text={translateString("aiAddOnPurchaseTooltip")}
            hoverText={translateString("aiAddOnPurchaseTooltip")}
            position={position}
        >
            {content}
        </PlanDialogWrapper>
    );
}

export default AiFeatureGate;
